<div class="container">
    <mat-tab-group [selectedIndex]="selected.value" (selectedTabChange)="selected.setValue($event.index)">
    <mat-tab label="Orden de Alquiler">
        <div  class="mt-4">
          <data-table
            title="Orden de Alquiler"
            [columns]='columnsRO'
            [configuration]='configurationRO'
            [reloadTable]='reloadTablaRO'
            [params]="[]"
            [url]='EndpointDictionary.RentalOrder.RENTAL_ORDER_TABLE'
            (add)='addRO($event)'
            (edit)='editarRO($event)'
            (view)='viewDetail($event)'
            (advance)="advanceRO($event)"
            [headerFilters]="headerFilters"
            [headerFileXlsm]="headerFileXlsm"
          ></data-table>

        </div>
      </mat-tab>

      <mat-tab *ngIf="currentState == stateTab.ADD && selected.value == 1"  label="Crear Orden">
        <div class="W-100 mt-3">
          <app-details-rental-order
          (completeOrder)="completeCreateOrder()">
          </app-details-rental-order>
        </div>
      </mat-tab>

      <mat-tab *ngIf="currentState == stateTab.EDIT && (selected.value == 1)"  label="Editar Orden">
        <div class="W-100">
          <app-details-rental-order
          (completeOrder)="completeCreateOrder()"
          >
          </app-details-rental-order>
        </div>
      </mat-tab>

      <mat-tab *ngIf="currentState == stateTab.DETAIL && selected.value == 1 || selected.value == 2" label="Detalle">
        <app-rental-order-summary
        [rentalOrderDetails]="detailsClickRow">
        </app-rental-order-summary>
      </mat-tab>
    </mat-tab-group>
    </div>
